
import React from 'react';
import { usePerksForm } from '@/hooks/usePerksForm';
import { Form } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { PerksFormHeader } from './perks/PerksFormHeader';
import { PerksFormFields } from './perks/PerksFormFields';

const PerksForm: React.FC = () => {
  const { form, isLoading, onSubmit } = usePerksForm();

  const handleSubmit = form.handleSubmit(onSubmit);

  return (
    <div className="max-w-3xl mx-auto">
      <Form {...form}>
        <form onSubmit={handleSubmit} className="space-y-6">
          <PerksFormHeader />
          
          <div className="bg-white shadow-sm rounded-lg p-6">
            <PerksFormFields form={form} />
            
            <div className="mt-6 flex justify-end">
              <Button 
                type="submit" 
                disabled={isLoading}
                className="flex items-center gap-2"
              >
                {isLoading && <Spinner className="h-4 w-4" />}
                Save Company Perks
              </Button>
            </div>
          </div>
        </form>
      </Form>
    </div>
  );
};

export default PerksForm;
